var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInitiative2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 32.0001 27.0553",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0624 0H16.9376V2.9174H15.0624V0ZM6.64903 2.75656L8.27301 1.81894L9.73177 4.34541L8.1078 5.28303L6.64903 2.75656ZM0.741351 9.35071L1.67898 7.72674L4.20545 9.18544L3.26782 10.8094L0.741351 9.35071ZM22.2679 4.34609L23.7266 1.81962L25.3506 2.75725L23.8919 5.28372L22.2679 4.34609ZM27.7935 9.18519L30.32 7.72649L31.2576 9.35047L28.7312 10.8092L27.7935 9.18519ZM5.87768 21.2977C5.19058 20.1076 4.69614 18.8154 4.40198 17.4574C2.90921 17.3246 0.822612 17.6666 0 17.9342C1.26461 23.1729 5.77598 27.1335 11.2982 27.0446H11.2987C11.6573 27.0446 12.0016 27.0298 12.3284 27.0042C12.2677 26.9769 12.2065 26.9491 12.145 26.9205C9.44492 25.6669 7.27768 23.7226 5.87768 21.2977ZM19.855 26.9205C19.7939 26.9489 19.7332 26.9765 19.6729 27.0036C25.616 27.5566 30.6136 23.6123 32.0001 17.9342C31.18 17.6671 29.0891 17.3244 27.5981 17.4575C26.6949 21.6701 23.8547 25.0704 19.855 26.9205Z",
    fill: "var(--fill-0, #B78E07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.00425 13.2901C5.53 18.4273 8.17974 23.0246 12.8626 25.1877C12.7721 25.066 12.6833 24.9431 12.5961 24.819C9.96642 21.0823 9.11074 16.5987 10.3433 12.3173C8.81095 11.3679 7.33462 10.8978 6.47907 10.6837C6.30992 11.2736 6.09764 12.1857 6.00425 13.2901ZM24.4983 20.3619C26.1493 17.738 26.4387 13.6151 25.5209 10.6836C24.666 10.8976 23.1895 11.3677 21.6567 12.3173C22.9413 16.7277 21.947 21.4356 19.1344 25.1891C21.4829 24.0832 23.2875 22.4592 24.4983 20.3619Z",
    fill: "var(--fill-0, #B78E07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.0007 25.9229C21.7467 20.578 21.7112 11.8654 16.0003 6.54297C9.59756 12.6726 10.9488 21.2492 16.0007 25.9229Z",
    fill: "var(--fill-0, #B78E07)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitiative2);
export default __webpack_public_path__ + "static/media/initiative-2.f66b181ee8f7a6e718844407abf7f155.svg";
export { ForwardRef as ReactComponent };